import type { IMasterDataPurchaserRepository } from "@src/domain/repositories/masterData";
import type { CreateMasterDataPurchaserDTO } from "@src/domain/dto/masterData";

export class CreateMasterDataPurchaserUseCase {
  private readonly repository: IMasterDataPurchaserRepository;

  constructor(repository: IMasterDataPurchaserRepository) {
    this.repository = repository;
  }

  execute(params: CreateMasterDataPurchaserDTO) {
    return this.repository.createPurchaser(params);
  }
}
